"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShiftHours = exports.mondaysInInterval = exports.dayArrayFromInterval = exports.getDateTime = void 0;
const luxon_1 = require("luxon");
const invoice_1 = require("../constants/invoice");
const math_1 = require("./math");
const getDateTime = (date, time, opts) => luxon_1.DateTime
    .fromFormat(`${date} ${time}`, `${invoice_1.INVOICE_DATE_FORMAT} ${invoice_1.INVOICE_TIME_FORMAT}`, opts);
exports.getDateTime = getDateTime;
const dayArrayFromInterval = (interval) => {
    let day = interval.start.startOf('day');
    let dayArray = [];
    while (day < interval.end) {
        dayArray = [...dayArray, day];
        day = day.plus({ days: 1 });
    }
    return dayArray;
};
exports.dayArrayFromInterval = dayArrayFromInterval;
const MONDAY = 1;
const mondaysInInterval = (interval) => exports.dayArrayFromInterval(interval)
    .reduce((mondays, day) => {
    if (mondays.length === 0
        && day.weekday !== MONDAY) {
        return [];
    }
    if (day.weekday === MONDAY) {
        return [
            ...mondays,
            day,
        ];
    }
    return mondays;
}, []);
exports.mondaysInInterval = mondaysInInterval;
const getShiftHours = (start, end) => math_1.round(luxon_1.Interval
    .fromDateTimes(start, end)
    .length('hours'));
exports.getShiftHours = getShiftHours;
//# sourceMappingURL=datetime.js.map